<template>
  <div class="view">
    <Title title="参加者"/>
    <EntryMain/>
  </div>
</template>

<script>
import Title from '@/components/Title.vue'
import EntryMain from '@/components/EntryMain'

export default {
  components: {
    Title,
    EntryMain
  },

  created: function () {
    this.$store.dispatch('event/getEvent', this.$route.params.id)
    this.$store.dispatch('entry/retrieveEntries', this.$route.params.id)
  }
}
</script>
